import { createStore } from 'vuex';

export default createStore({
	state: {
		leftDictionary: {},
		rightDictionary: {},
	},
	mutations: {
		setLeftDictionary(state, leftDictionary) {
			state.leftDictionary = leftDictionary;
		},
		setRightDictionary(state, rightDictionary) {
			state.rightDictionary = rightDictionary;
		},
	},
	getters: {
		getLeftText: (state) => (key) => {
			return state.leftDictionary[key] || key;
		},
		getRightText: (state) => (key) => {
			return state.rightDictionary[key] || key;
		},
	},
});
